export default {
  ENTRANCE: 'Entrance to the account',
  FORGOT: 'Forgot password?',
  SEND: 'Send',
  NO_ACCOUNT: "Don't have an account?",
  REGISTRATION: ' Register',
  ERROR: 'Invalid authorization data. Please try again',
};
